import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { RestfulService } from '@app/service/restful.service';

@Injectable({
  providedIn: 'root'
})
export class AgGridService {

  constructor(
    private restful: RestfulService,
  ) { }

  private extractData(res: Response) {
    let body = res;
    return body || [ ];
  }

  private handleErrorPromise(error: Response | any) {
    console.error(error.message || error);
    return Promise.reject(error.message || error);
  }

  // ag grid 기본 정보 가져오기
  getGridInfo( menuseq ): Promise<any> {
    return this.restful.get({
        program: 'fms',
        service: 'grid',
        version: '1.0',
        action: 'getGridInfo'
      }, {
        menuseq: menuseq
      }
    ).then(this.extractData)
     .catch(this.handleErrorPromise);
  }

  // ag grid 컬럼 정보 저장하기
  setGridInfo( menuseq, gridNumber, gridJSON ): Promise<any> {
    return this.restful.post({
        program: 'fms',
        service: 'grid',
        version: '1.0',
        action: 'setGridInfo'
      }, {
        menuseq: menuseq,
        gridNumber: gridNumber,
        gridInfo: gridJSON
      }
    ).then(this.extractData)
     .catch(this.handleErrorPromise);
  }
}
